import { IOfferListModalLang } from '../../../types/lang'

export const offerListModalLang: IOfferListModalLang = {
	offer_list_modal: {
		title_bind: 'Binding offers to scope',
		title_unbind: 'Unbinding offers from scope',
		title_unscoped: 'Unscoped offers',
		title_unscoped_in_group: 'Unscoped offers in group',
		title_view: 'View offers in scope',
		btn_close: 'Close'
	}
}